import { ArrowRightIcon, NewspaperIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import type { NewsArticle } from '../../../../Model/News/newsArticle.js'
import { formatNewsDate } from '../../../../Model/News/newsArticle.js'
import { newsImageUrl } from '../../../../Model/News/newsArticles.js'
import { DASHBOARD_WIDGET_CLASS } from './dashboardUtils.ts'

export const LatestNewsWidget = ({ article }: { article: NewsArticle }) => {
  const heroUrl = newsImageUrl(article, article.hero)
  const articleLink = `/news/${article.slug}`

  return (
    <section data-testid="latest-news-widget" className={`${DASHBOARD_WIDGET_CLASS} xl:col-span-12`}>
      <div className="mb-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <NewspaperIcon className="h-5 w-5 text-slate-600" />
          <h2 className="text-lg font-semibold text-slate-900">News</h2>
        </div>
        <Link to="/news" className="text-sm font-medium text-slate-500 hover:text-slate-900">
          All news
        </Link>
      </div>
      <Link to={articleLink} className="group flex flex-col gap-5 sm:flex-row sm:items-center">
        {heroUrl && <img src={heroUrl} alt="" className="h-32 w-full shrink-0 rounded-lg bg-emerald-50 object-contain sm:w-56" />}
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">{formatNewsDate(article.date)}</p>
          <h3 className="mt-1 text-xl font-bold text-slate-900 transition-colors group-hover:text-primary-600">{article.title}</h3>
          {article.teaser && <p className="mt-1 text-sm text-slate-600">{article.teaser}</p>}
          <span className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-slate-700 group-hover:text-slate-900">
            Read more
            <ArrowRightIcon className="h-4 w-4" />
          </span>
        </div>
      </Link>
    </section>
  )
}
